export const tr = {
    allTime: 'Tüm zamanlar',
    currentMonth: 'Bu ay',
    currentWeek: 'Bu hafta',
    defaultBudgetMode: 'standart',
    last30Days: 'Son 30 gün',
    last365Days: 'Son 365 gün',
    last7Days: 'Son 7 gün',
    last90Days: 'Son 90 gün',
    previousMonth: 'Geçen ay',
    previousWeek: 'Geçen hafta',
    'report-enqueued': 'Rapor talebi sıraya eklendi',
    stretchedBudgetMode: 'dağıtılmış',
    today: 'Bugün',
    yesterday: 'Dün'
};
